export const isPositiveUserId = (
  value: number | null | undefined
): value is number => typeof value === 'number' && value > 0;
